import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['trigger', 'menu'];

  connect() {
    this.#onOutsideClick = (event) => {
      if (!this.element.contains(event.target)) this.close();
    };

    this.#onKeydown = (event) => {
      if (event.key === 'Escape') this.close();
    };

    this.#onBeforeMorph = (event) => {
      if (event.target === this.element && this.#open) event.preventDefault();
    };

    window.addEventListener('mousedown', this.#onOutsideClick);
    window.addEventListener('keydown', this.#onKeydown);
    document.addEventListener('turbo:before-morph-element', this.#onBeforeMorph);
  }

  disconnect() {
    window.removeEventListener('mousedown', this.#onOutsideClick);
    window.removeEventListener('keydown', this.#onKeydown);
    document.removeEventListener('turbo:before-morph-element', this.#onBeforeMorph);
  }

  toggle() {
    if (this.#open) {
      this.close();
    } else {
      this.open();
    }
  }

  open() {
    this.menuTarget.classList.remove('hidden');
    this.triggerTarget.setAttribute('aria-expanded', 'true');
    this.menuTarget.scrollIntoView({ block: 'nearest' });
    this.menuTarget.querySelector('[data-role="autofocus"]')?.focus();
  }

  close() {
    if (!this.#open) return;

    this.menuTarget.classList.add('hidden');
    this.triggerTarget.setAttribute('aria-expanded', 'false');
    this.dispatch('closed');
  }

  get #open() {
    return !this.menuTarget.classList.contains('hidden');
  }

  #onOutsideClick;
  #onKeydown;
  #onBeforeMorph;
}
